<template>
  <a-table
    ref="table"
    bordered
    :rowKey="rowKey"
    :childrenColumnName='childrenColumnName'
    :dataSource="dataSource"
    :columns="tableColumns"
    :row-selection="rowSelection"
    :pagination="false"
    @change="change"
    :loading="loading"
    :defaultExpandAllRows='true'
    tableLayout='fixed'
    :scroll="{ x: 'max-content',y: tableHeight}"
    @resizeColumn="handleResizeColumn"
  >
  <template #headerCell="{ column }">
    <slot name="headerCell" :column="column"></slot>
  </template>
  <template #bodyCell="{ column, record, index, text }">
    <slot name="bodyCell" :column="column" :record="record" :index='index' :text='text'></slot>
  </template>
  </a-table>
  <div class="pagination" v-if="showPagination">
    <a-pagination 
    :current="current"
    :pageSize="pageSize"
    :total="total"
    :show-quick-jumper='true'
    :show-size-changer='true'
    :page-size-options='pageSizeOptions'
    :show-total='total => `共${total}条`'
    @change="change" />
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, computed } from "vue";
export default defineComponent({
  emits: ['checkChange', 'paginationChange'],
  props: {
    showSelect: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    rowKey: { // 每一列的唯一key 默认id
      type: String,
      default: 'id'
    },
    childrenColumnName: { // 指定树形结构的列名
      type: String,
      default: 'children'
    },
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * 表头 
     * @param { title: "住址", dataIndex: "address", }
     * */
    columns: {
      type: Array,
      default: () => []
    },
    // 表格内容
    dataSource: {
      type: Array,
      default: () => []
    },
    // 分页参数
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    pageSizeOptions: {
      type: Array,
      default: () => ["10", "20", "30", "40"]
    },
  },
  setup(props, {emit}) {
    // 表头添加公用设置
    const tableColumns: any[] = reactive([]);
    props.columns.forEach((item: any) => {
      if(item.sorter) {
        item.showSorterTooltip = false // 取消点击筛选提示
        item.sorter = true // 服务端筛选
      }
      tableColumns.push(item)
    });
    // 复选框操作
    // const rowSelection = reactive({
    //   type: "checkbox",
    //   onChange(selectedRowKeys: any, selectedRows: any) {
    //     emit('checkChange',selectedRowKeys, selectedRows)
    //   }
    // });
    const rowSelection = computed(() => {
      return props.showSelect ? {
        type: "checkbox",
        onChange(selectedRowKeys: any, selectedRows: any) {
        emit('checkChange',selectedRowKeys, selectedRows)
      }
      } : undefined; 
    });
    // 分页、排序、筛选变化时触发
    const change = (page: number, pageSize: number) => {
      emit('paginationChange',page, pageSize)
    }
    const handleResizeColumn=(w:number, col:any)=> {
      col.width = w;
    }
    const tableHeight = computed(() => {
      return props.dataSource.length > 0 ? 'calc(100vh - 400px)' : undefined;
    });
    return {
      tableColumns,
      rowSelection,
      tableHeight,
      change,
      handleResizeColumn
    };
  },
});
</script>
